import { DashboardLayout } from "@/components/layouts";
import { authMiddleware } from "@/middleware";
import { HistoryPage } from "@/pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_dashboard/history/")({
	component: RouteComponent,
	loader: ({ location }) => authMiddleware(location.pathname),
});

function RouteComponent() {
	return (
		<DashboardLayout>
			<HistoryPage />
		</DashboardLayout>
	);
}
